<div [ngClass]="['file', extension, type, subtype].join(' ')">
  <span class="title">{{extension | uppercase}}</span>
</div>